<template>
  <div class="split d-flex">
    <div class="left">
      <div v-if="step === 'initial'">
        <!--        <div class="question-container" :class="{empty: type === ''}">-->
        <!--          <div class="size3 w-bold">Vill du skapa en presentation eller en mall? {{kind}}</div>-->
        <!--          <div>-->
        <!--            <b-form-radio-group v-model="type" class="pt-2">-->
        <!--              <b-form-radio value="presentation" class="size3">Presentation</b-form-radio>-->
        <!--              <b-form-radio value="template" class="size3">Mall</b-form-radio>-->
        <!--            </b-form-radio-group>-->
        <!--          </div>-->
        <!--        </div>-->

        <h2 class="mb-2"></h2>

        <template v-if="type === 'presentation'">
          <div class="question-container" :class="{ empty: basedOn === '' }">
            <div class="size3 w-bold">
              Vill du skapa en presentation från grunden eller basera den på en
              mall?
            </div>
            <div>
              <b-form-radio-group v-model="basedOn" class="pt-2">
                <b-form-radio value="custom" class="size3"
                  >Egen presentation</b-form-radio
                >
                <b-form-radio value="customTemplate" class="size3"
                  >Egen mall</b-form-radio
                >
                <b-form-radio value="template" class="size3"
                  >Allmän snabbmall</b-form-radio
                >
              </b-form-radio-group>
            </div>
          </div>

          <div
            v-if="basedOn === 'custom'"
            class="question-container"
            :class="{ empty: basedOnCompany === '' }"
          >
            <div class="size3 w-bold">
              Vill du skapa en allmän presentation eller knyta den till ett
              aktiebolag?
            </div>
            <div>
              <b-form-radio-group v-model="basedOnCompany" class="pt-2">
                <b-form-radio value="no" class="size3"
                  >Allmän presentation</b-form-radio
                >
                <b-form-radio value="yes" class="size3"
                  >Knuten till ett aktiebolag</b-form-radio
                >
              </b-form-radio-group>
            </div>
          </div>

          <div v-if="basedOn === 'customTemplate'">
            <div
              v-if="customTemplates.length === 0"
              class="h3 mt-3 ml-0 text-black-50"
            >
              <PValue>Du har inte skapat några mallar ännu.</PValue>
            </div>

            <div v-if="customTemplates.length > 0" class="question-container">
              <div class="size3 w-bold mb-3">Vilken mall vill du använda?</div>
              <div class="flex">
                <v-select
                  v-model="selectedCustomTemplate"
                  class="my-templates-list"
                  :options="customTemplates"
                />
                <!--              <div @click="createTemplate()" class="button template-button">Skapa ny mall</div>-->
              </div>
            </div>
          </div>

          <div
            v-if="selectedStaticTemplate.id !== 0"
            class="question-container"
          >
            <div class="size2 w-bold">
              {{ selectedStaticTemplate.Title }}
              <span
                @click="selectedStaticTemplate = { id: 0 }"
                class="btn btn-link pl-10"
                >Byt mall</span
              >
            </div>
          </div>

          <div
            v-if="
              selectedStaticTemplate.id !== 0 ||
                (basedOn === 'custom' && basedOnCompany === 'yes') ||
                (basedOn === 'customTemplate' && selectedCustomTemplate)
            "
            class="question-container"
            :class="{ empty: company === null || company === undefined }"
          >
            <div class="size3 w-bold mb-3">
              Vilket bolag vill du knyta till presentationen?
            </div>
            <CompanySelection
              style="margin-left: 0rem; width: calc(100% / 3 * 2)"
              :locked="false"
              :disabled="false"
              :disabledSource="false"
              :company="company"
              :use-sie="selectedStaticTemplate.type !== 'deck-salesmeeting'"
              :useLatest="
                selectedStaticTemplate.id === 0 ||
                  selectedStaticTemplate.type === 'deck-esgintroduction' ||
                  selectedStaticTemplate.type === 'deck-esgkpi' ||
                  selectedStaticTemplate.type === 'deck-company' ||
                  selectedStaticTemplate.type === 'deck-salesmeeting'
              "
              :use-branch="false"
              :sheet-limit="1"
              @company="company = $event || {}"
              @source="source = $event || {}"
            />

            <div
              v-if="
                selectedStaticTemplate.langEN === true ||
                  selectedStaticTemplate.langEN === false
              "
            >
              <b-form-checkbox
                v-model="selectedStaticTemplate.langEN"
                class="adjust"
                switch
                size="lg"
                >Skapa presentation på engelska</b-form-checkbox
              >
            </div>
          </div>

          <div v-if="basedOn === 'template' && selectedStaticTemplate.id === 0">
            <div class="item-container items-title">
              Välj snabbmall
            </div>

            <div v-for="t in templates" :key="t.id" class="">
              <a
                @click="select(t)"
                class=""
                v-if="enabledTemplates.includes(t.type)"
              >
                <TemplateItem
                  v-if="t.type.startsWith('deck-')"
                  class="item slimmest"
                  :documentName="t.Title"
                  :deckTitle="t.deckTitle"
                  :description="t.Description"
                  :pages="t.Pages"
                />
                <TemplateSelection
                  v-else
                  :type="t.type"
                  :title="t.Title"
                  :description="t.Description"
                  :icon="t.Icon"
                  class=""
                />
              </a>
            </div>
          </div>

          <div
            v-if="
              (basedOn === 'custom' &&
                basedOnCompany === 'no' &&
                title !== '') ||
                (basedOn === 'custom' &&
                  basedOnCompany === 'yes' &&
                  company.value &&
                  title !== '')
            "
          >
            <div
              class="button button-secondary button-special"
              @click="createPresentation()"
            >
              Skapa egen presentation
            </div>
          </div>

          <div
            v-if="
              basedOn === 'customTemplate' &&
                selectedCustomTemplate &&
                company.value
            "
          >
            <div
              class="button button-secondary button-special"
              @click="createPresentationFromTemplate()"
            >
              Skapa presentation
            </div>
          </div>

          <div v-if="selectedStaticTemplate.id !== 0 && company.value">
            <div
              class="button button-secondary button-special"
              @click="createPresentationFromStaticTemplate()"
            >
              Skapa presentation
            </div>
          </div>
        </template>

        <template v-if="type === 'template'">
          <div class="question-container">
            <div class="size3 w-bold mb-1">Vilken titel vill du ge mallen?</div>
            <input
              type="text"
              v-model="name"
              class="size3"
              style="width: calc(100% / 3 * 2)"
            />
          </div>

          <div class="question-container">
            <div class="size3 w-bold mb-1">Vill du skapa en ny mall eller kopiera en befintlig mall?</div>
            <b-form-radio-group v-model="duplicate" class="pt-2">
              <b-form-radio value="new" class="size3">Ny mall</b-form-radio>
              <b-form-radio value="duplicate" class="size3">Kopiera en befintlig mall</b-form-radio>
            </b-form-radio-group>
          </div>

          <div class="question-container" v-if="duplicate === 'duplicate'">
            <div class="size3 w-bold mb-1">Välj mall att kopiera</div>
            <v-select
                  v-model="selectedTemplatesToDuplicate"
                  class="my-templates-list"
                  :options="customTemplates"
                />

          </div>

          <div
            class="question-container"
            :class="{ empty: company === null || company === undefined }"
          >
            <div class="size3 w-bold mb-3">
              Vilket exempelbolag vill du använda till förhandsvisningen?
            </div>
            <CompanySelection
              style="margin-left: 0rem; width: calc(100% / 3 * 2)"
              :locked="false"
              :disabled="false"
              :disabledSource="false"
              :company="company"
              :useLatest="true"
              :use-branch="false"
              :sheet-limit="1"
              @company="company = $event || {}"
              @source="source = $event || {}"
            />
          </div>

          <div v-if="company.value && name && (duplicate === 'new' || selectedTemplatesToDuplicate)">
            <div
              class="button button-secondary button-special"
              @click="createTemplate()"
            >
              Skapa mall
            </div>
          </div>
        </template>
      </div>

      <div v-if="step === 'content'">
        <div v-if="!typed" class="item-container items-title">
          Skapa innehåll
        </div>

        <CreateDocumentCompetitors
          class="card card-page"
          v-if="selectedTemplate.type === 'competitors'"
          v-on:prev="prev()"
        />
        <CreateDocumentValuation
          class="card card-page"
          v-if="selectedTemplate.type === 'valuation'"
          v-on:prev="prev()"
        />
        <CreateDocumentClosingMeeting
          class="card card-page"
          v-if="selectedTemplate.type === 'closingmeeting'"
          v-on:prev="prev()"
        />
        <CreateDocumentFutureMeeting
          class="card card-page"
          v-if="selectedTemplate.type === 'futuremeeting'"
          v-on:prev="prev()"
        />
        <CreateDocumentYearEndMeeting
          class="card card-page"
          v-if="selectedTemplate.type === 'yearendmeeting'"
          v-on:prev="prev()"
        />
        <CreateDocumentYearReview
          class="card card-page"
          v-if="selectedTemplate.type === 'yearreview'"
          v-on:prev="prev()"
        />

        <DocumentEditor
          class=""
          v-if="typed"
          v-on:prev="prev()"
          :subType="selectedTemplate.type"
        />
      </div>
    </div>
    <div class="right">
      <AboutDocument :type="selectedTemplate.type" class="sticky-about" />

      <div v-if="step === 'initial' && type === 'template'" class="mt-4">
        <div>
          <h3>Skapa mall</h3>
          <p>
            Med Egen mall skapar du en åter&shy;användbar mall för dina
            presentationer där all bolags&shy;data automagiskt ersätts baserat
            på det bolag du väljer.
          </p>
          <p>
            Under skapandet av mallen använder du ett exempel&shy;bolag för att
            i förhands&shy;granskningen kunna se hur presentationen växer fram.
          </p>
          <p>
            När mallen är skapad använder du den under "Skapa presentation" i
            vänster&shy;menyn och väljer därefter "Egen mall".
          </p>
          <p>
            Vill du senare redigera mallen kan du göra detta via "Egna mallar" i
            vänstermenyn.
          </p>
        </div>
      </div>

      <div v-else-if="step === 'initial'" class="mt-4">
        <div v-if="basedOn === ''">
          <h3>Skapa presentation</h3>
          <p>
            I Analyscenter är det enkelt att snabbt skapa presentationer från
            grunden, via egna mallar eller via allmänna snabb&shy;mallar avsedda
            för specifika tillfällen.
          </p>
          <p>
            Med Egen presentation och Egen mall ser du direkt via
            förhands&shy;granskningen hur presentationen växer fram och det är
            enkelt att lägga till, ta bort och flytta omkring innehåll.
          </p>
          <p>
            Alla presentationer följer den visuella identiteten så att du kan
            fokusera på innehållet istället för att behöva bry dig om
            fontstorlek, färger och liknande.
          </p>
        </div>
        <div v-if="basedOn === 'custom'">
          <h3>Egen presentation</h3>
          <p>
            Med Egen presentation skapar du snabbt & enkelt en presentation från
            grunden. Presentationens utseende är hårt styrt för att automatiskt
            följa den visuella identiteten så att du istället kan fokusera på
            innehållet.
          </p>
          <p>
            Du kan enkelt välja mella olika innehålls&shy;sidor som punkter,
            text, diagram, importera bilder eller bädda in en PDF. Du har även
            tillgång till ett innehålls&shy;bibliotek med ytterligare
            komponenter.
          </p>
          <p>
            Välj mellan att skapa en allmän presentation eller en med
            utgångs&shy;punkt från ett valt bolag. För bolags&shy;baserade
            presentationer finns såväl färdiga sidor och färdiga ekonomiska
            diagram att tillgå.
          </p>
        </div>
        <div v-if="basedOn === 'customTemplate'">
          <h3>Egen mall</h3>
          <p>
            Med en Egen mall blir det ännu enklare att snabbt skapa en snygg
            presentation på kortast möjlig tid.
          </p>
          <p>
            Med Egen mall får du ett utkast till presentation som automagiskt
            populerar presentationens diagram, tabeller och färdiga sidor med
            data för ditt valda bolag.
          </p>
          <p>
            Det första du måste göra innan du kan använda Egen mall är att skapa
            en mall via navigeringen längst till vänster.
          </p>
        </div>
        <div v-if="basedOn === 'template'">
          <h3>Allmän snabbmall</h3>
          <p>
            De allmänna snabbmallarna är skapade med specifika tillfällen i
            åtanke.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* tslint:disable */

import TemplateSelection from '@/views/TemplateSelection';
import CreateDocumentValuation from '@/views/CreateDocumentValuation';
import CreateDocumentCompany from '@/views/CreateDocumentCompany';
import CreateDocumentCompetitors from '@/views/CreateDocumentCompetitors';
import CreateDocumentClosingMeeting from '@/views/CreateDocumentClosingMeeting';
import CreateDocumentYearEndMeeting from '@/views/CreateDocumentYearEndMeeting';
import CreateDocumentPreClosingMeeting from '@/views/CreateDocumentPreClosingMeeting';
import CreateDocumentFutureMeeting from '@/views/CreateDocumentFutureMeeting';
import CreateDocumentYearReview from '@/views/CreateDocumentYearReview';
import DocumentEditor from '@/views/document/DocumentEditor';
import TemplateItem from '@/views/TemplateItem';
import { templates } from '@/config';
import user from '@/store/modules/user';
import search from '@/store/modules/search';
import AboutDocument from '@/views/document/AboutDocument';
import deck, { createFromTemplate } from '@/store/modules/deck';
import CompanySelection from '@/components/CompanySelection.vue';
import * as api from '@/store/api';

export default {
  name: 'CreateDocument',
  components: {
    CompanySelection,
    AboutDocument,
    DocumentEditor,
    CreateDocumentClosingMeeting,
    CreateDocumentCompetitors,
    CreateDocumentCompany,
    CreateDocumentValuation,
    TemplateSelection,
    CreateDocumentPreClosingMeeting,
    CreateDocumentFutureMeeting,
    CreateDocumentYearEndMeeting,
    CreateDocumentYearReview,
    TemplateItem,
  },
  props: {
    type: String,
  },
  data() {
    return {
      // type: 'presentation',
      basedOn: '',
      basedOnCompany: '',
      title: 'Presentation',
      name: '',
      company: {},
      source: {},
      selectedCustomTemplate: null,

      duplicate: 'new',
      selectedTemplatesToDuplicate: null,

      step: 'initial',
      documentTitle: undefined,
      selectedTemplate: { id: 0 },
      selectedStaticTemplate: { id: 0 },
      templates: [
        {
          id: 19,
          type: 'deck-salesmeeting',
          Title: 'Säljmöte',
          deckTitle: 'Möte med',
          Description:
            'En bolagskopplad presentation för ett säljmöte. Innehåller agenda, team, företagspresentation, genomgång av bolaget och nästa steg. Kan med fördel anpassas efter kundens behov.',
        },
        {
          id: 14,
          type: 'deck-yearendmeeting',
          Title: 'Bokslutsmöte',
          deckTitle: 'Bokslut {20ÅÅ-MM-DD}',
          Description:
            'En SIE-baserad presentation där vi går igenom bokslutet och summerar året för att därefter fokusera på innevarande år och framtiden. Kan med fördel anpassas efter kundens behov.',
          langEN: false,
        },
        {
          id: 15,
          type: 'deck-startupmeeting',
          Title: 'Uppstartsmöte: Inför årsavslut',
          deckTitle: 'Inför årsavslut',
          Description:
            'En SIE-baserad presentation för att förbereda årsavslutet tillsammans med kunden. Innehåller en genomgång av vad som behöver göras och vad som är viktigt att tänka på inklusive Ekonomiskt nuläge, Planering, Hållbarhet och Övrigt. Kan med fördel anpassas efter kundens behov.',
          langEN: false,
        },
        {
          id: 16,
          type: 'deck-esgintroduction',
          Title: 'Introduktionsmöte: Hållbarhet',
          deckTitle: 'Hållbarhet',
          Description:
            'En mall för att introducera hållbarhet till kunden. Innehåller en genomgång av vad hållbarhet är, varför det är viktigt och hur vi kan hjälpa till. Kan med fördel anpassas efter kundens behov.',
          langEN: false,
        },
        {
          id: 17,
          type: 'deck-esgkpi',
          Title: 'Klimat- och Sociala nyckeltal i Budget & Rapport',
          deckTitle: 'Klimatnyckeltal',
          Description:
            'En mall för att introducera klimat- och sociala nyckeltal i Budget & Rapport till kunden. Innehåller en genomgång av vad klimat- och sociala nyckeltal är, varför det är viktigt och hur vi kan hjälpa till. Kan med fördel anpassas efter kundens behov.',
          langEN: false,
        },
        {
          id: 18,
          type: 'deck-company',
          Title: 'Bolagspresentation',
          deckTitle: 'Bolagspresentation',
          Description:
            'En övergripande presentation av ett bolag. Innehåller en översikt om bolagets verksamhet och dess ekonomi genom en resultat-, balans- och likviditetsöversikt. Kan med fördel anpassas efter kundens behov.',
          langEN: false,
        },
        {
          id: 10,
          type: 'flexible',
          Title: 'Flexibel presentation',
          Description: 'Välj fritt vad som skall ingå i presentationen.',
          Icon: 'puzzle',
        },
        {
          id: 1,
          type: 'company',
          Title: 'Bolagsanalys',
          Description:
            'Det snabbaste sättet för att skapa en snygg presentation av ett bolag.',
          Icon: 'aim',
        },
        {
          id: 12,
          type: 'competitorAnalysis',
          Title: 'Konkurrentjämförelse',
          Description:
            'Paketerade tjänster har fördefinierade priser, leveransformat och tidsinsatser.',
          Icon: 'gift',
        },
        {
          id: 11,
          type: 'industryAnalysis',
          Title: 'Branschjämförelse',
          Description:
            'Paketerade tjänster har fördefinierade priser, leveransformat och tidsinsatser.',
          Icon: 'gift',
        },
        // {
        //   id: 2,
        //   type: 'competitors',
        //   Title: 'Konkurrentjämförelse',
        //   Description:
        //     'En jämförelse mellan ett huvudbolag och en eller två utvalda konkurrenter.',
        //   Icon: 'compare',
        // },
        {
          id: 3,
          type: 'valuation',
          Title: 'Förenklad kassaflödesvärdering',
          Description:
            'Värdera ett företag snabbt samtidigt som du enkelt kan justera värdet.',
          Icon: 'trophy2',
        },
        {
          id: 4,
          type: 'closingmeeting',
          Title: 'Bokslutsmöte',
          Description:
            'Bokslutsmötet är främst tänkt att användas av Ekonomiservice i samband med att bokslutsarbetet avslutas.',
          Icon: 'calendar-31',
        },
        // {
        //   id: 5,
        //   type: "preClosingMeeting",
        //   Title: "Inför Bokslut",
        //   Description:
        //       "Inför bokslut kan användas av såväl Ekonomiservice som Revision i samband med årsavslutet.",
        //   Icon: "hourglass",
        // },
        // {
        //   id: 6,
        //   type: "futuremeeting",
        //   Title: "Framtidsmöte",
        //   Description:
        //       "Framtidsmötet är tänkt att kunna användas i samband med framtidsriktad rådgivning. ",
        //   Icon: "binoculars2",
        // },
        {
          id: 7,
          type: 'yearendmeeting',
          Title: 'Årsavslutsmöte',
          Description:
            'Årsavslutsmötet är främst tänkt att användas av Revision i samband med att revisionsarbetet avslutas.',
          Icon: 'calendar-31',
        },
        {
          id: 8,
          type: 'yearreview',
          Title: 'Årsgenomgång',
          Description:
            'Gör det enkelt att med kunden pedagogiskt och stegvis gå igenom bolagets senaste bokslutsår.',
          Icon: 'calendar-31',
        },
        // {
        //   id: 9,
        //   type: 'cashflow',
        //   Title: 'Förenklad kassaflödesanalys',
        //   Description:
        //     'Med en automatisk kategorisering blir det enkelt att skapa en kassaflödesanalys.',
        //   Icon: 'tab',
        // },
        {
          id: 13,
          type: 'webreport_cashflow',
          Title: 'Grundlig kassaflödesgenomgång',
          Description:
            'En delbar webbrapport som grundligt går igenom ett bolags kassaflöden.',
          Icon: 'new-tab',
        },
      ],
      customTemplatesRaw: [],
    };
  },
  async mounted() {
    await user.setActiveSie(null);
    await user.setSelectedDocument(null);
    await user.setSelectedDocumentBlob(null);
    await user.setActiveExternalUser(null);
    await search.setTerm('');
    this.customTemplatesRaw = await api.getTemplates();

    if (this.$route.params.TemplateId) {
      this.selectedTemplatesToDuplicate = this.customTemplates.find(t => t.value === this.$route.params.TemplateId);
      this.duplicate = 'duplicate';
    }
  },
  updated() {
    window.document.getElementById('main-content').scrollTo(0, 0);
  },
  watch: {
    basedOn() {
      this.selectedStaticTemplate = { id: 0 };
      this.source = {};
      this.company = {};
    },
  },
  methods: {
    async createPresentation() {
      const id = await deck.create({
        type: 'deck',
        orgNr: this.company.value || '00',
        name: '',
        title: this.title,
        sieAggVersion: this.source.id,
        basedOn: this.source.source,
      });
      await user.getUser('Skapar presentation');
      this.$router.push({
        name: 'editpresentation',
        params: { DocumentId: id.data },
      });
    },
    async createTemplate() {
      if (this.duplicate === 'duplicate') {
        const template = await api.getTemplate(this.selectedTemplatesToDuplicate.value);
        const id = await createFromTemplate({
          type: 'deck-template',
          name: this.name,
          userId: user.user.UserId,
          template: template,
          orgNr: this.company.value || '00',
          sieAggVersion: this.source.id,
          basedOn: this.source.source,
        });
        await user.getUser('Skapar mall');
        this.$router.push({
          name: 'editpresentation',
          params: { DocumentId: id.data },
        });
      } else {
        const id = await deck.create({
          type: 'deck-template',
          orgNr: this.company.value || '00',
          name: this.name,
          title: this.title,
          sieAggVersion: this.source.id,
          basedOn: this.source.source,
        });
        await user.getUser('Skapar mall');
        this.$router.push({
          name: 'editpresentation',
          params: { DocumentId: id.data },
        });
      }
    },
    async createPresentationFromStaticTemplate() {
      const id = await deck.createByTemplate({
        type: 'deck',
        template: this.selectedStaticTemplate.type,
        orgNr: this.company.value || '00',
        name: '',
        title: this.selectedStaticTemplate.Title,
        sieAggVersion: this.source.id,
        basedOn: this.source.source,
        langEN: this.selectedStaticTemplate.langEN,
      });
      await user.getUser('Skapar presentation');
      this.$router.push({
        name: 'editpresentation',
        params: { DocumentId: id.data },
      });
    },
    async createPresentationFromTemplate() {
      const template = await api.getTemplate(this.selectedCustomTemplate.value);
      const id = await createFromTemplate({
        type: 'deck',
        name: template.Name,
        userId: user.user.UserId,
        template: template,
        orgNr: this.company.value || '00',
        sieAggVersion: this.source.id,
        basedOn: this.source.source,
      });
      await user.getUser('Skapar presentation');
      this.$router.push({
        name: 'editpresentation',
        params: { DocumentId: id.data },
      });
    },
    select(template) {
      if (template.type.startsWith('deck-')) {
        this.selectedStaticTemplate = template;
        this.basedOn = 'template';
      } else {
        this.selectedTemplate = template;
        this.next();
      }
    },
    prev() {
      this.step = 'initial';
      this.selectedTemplate = { id: 0 };
    },
    next() {
      if (this.selectedTemplate.id === 0) return;
      this.step = 'content';
    },
  },
  computed: {
    customTemplates() {
      return this.customTemplatesRaw.map((t) => {
        // console.log(t);
        let sharedBy = null;
        if (t.SharedBy && t.SharedBy.UserId !== user.user.UserId) {
          sharedBy = `skapad av ${t.SharedBy.FirstName} ${t.SharedBy.LastName}`;
        }
        let label = t.Data.Name || t.Data.Slides[0].title;
        if (sharedBy) {
          label += ` (${sharedBy})`;
        }
        return { label: label, value: t.Id };
      });
    },
    enabledTemplates() {
      return templates;
    },
    typed() {
      if (!this.selectedTemplate) {
        return false;
      }
      switch (this.selectedTemplate.type) {
        case 'flexible':
        case 'cashflow':
        case 'company':
        case 'industryAnalysis':
        case 'competitorAnalysis':
        case 'webreport_cashflow':
        case 'preClosingMeeting':
          return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.item:hover {
  border-color: col('colors.Secondary');
}

.description {
  background: col('colors.White');
  border: 1px solid col('colors.DarkGrey');
  border-radius: 0.2rem;
  padding: 1rem;
}

.sticky-about {
  position: sticky;
  top: 1rem;
}
</style>

<style lang="scss" scoped>
input,
textarea,
select {
  accent-color: col('colors.Primary');
  margin-top: 1rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid col('colors.LightGrey');

  &:focus {
    outline-color: col('colors.Secondary');
    background-color: rgba(col('colors.Secondary'), 0.15);
  }
}

.question-container {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid col('colors.Light');
  background-color: col('colors.Light');
  transition: 0.5s;

  &.empty {
    border-color: col('colors.Primary');
    background-color: rgba(col('colors.White'), 1);
  }

  &:focus-within {
    border-color: col('colors.Primary');
    background-color: rgba(col('colors.White'), 1);
  }
}

.button-special {
  width: 50%;
  margin: 2rem auto;
}

.beta-tag {
  text-transform: uppercase;
  color: col('colors.Secondary');
}

.my-templates-list {
  width: calc(100% / 3 * 2);
  font-size: 1.25rem;
  background-color: col('colors.White');
}

.flex {
  display: flex;
}

.template-button {
  position: relative;
  top: -0.5rem;
  margin-left: 2rem;
}

.template-name {
  width: calc(100% / 3 * 2);
}

.template-item-wrapper {
  padding: 0 1rem;
}
</style>
